<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {};
</script>

<style lang="scss" src="@/assets/sass/app.scss"></style>
